import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { DialogService, SpinnerService } from 'dspx-core';

import { APP_DATA_KEYS } from '../../constants/app-data.constants';

import { Logger } from '../../helpers/logger';

import { AppDataService } from '../../services/app-data.service';
import { ServiceWorkerService } from '../../services/service-worker.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {

  protected componentClassName: string;
  private logger: Logger;

  constructor(
    private appDataService: AppDataService,
    private serviceWorkerService: ServiceWorkerService,
    private spinnerService: SpinnerService,
    private dialogService: DialogService,
    private router: Router) {

    this.componentClassName = this.constructor.name;
    this.logger = new Logger(this.componentClassName, this.appDataService.getAppData(APP_DATA_KEYS.logLevel));
  }

  ngOnInit(): void {

    const logPrefix = 'ngOnInit';
    this.logger.log(`${logPrefix}: enter`);

    this.spinnerService.showSpinner();
    this.serviceWorkerService.waitForServiceWorker()
      .then(waitResult => {
        const userProfile = waitResult.loggedInUserProfile;
        if (userProfile.defaultClientRoute) {
          // User is authenticated
          this.router.navigate(['/', userProfile.defaultClientRoute]);
        }
        else {
          // User is authenticated but is not authorised
          this.dialogService.showSimplePopup(`User ${userProfile.emailAddress} is not authorised to access this application.`, 'Unauthorised User', 'Close');
        }
      })
      .finally(() => {
        this.spinnerService.hideSpinner();
      });

    this.logger.log(`${logPrefix}: leave`);
  }
}
